import userReducer from "../slices/user";
import webJournalReducer from "../slices/webJournal";

const rootReducer = {
  userReducer,
  webJournalReducer,
};

export default rootReducer;
